import { createSlice } from "@reduxjs/toolkit";

export const CourseDetailsSlice = createSlice({
    name:'course',
    initialState:{
        details:'',
    },

    reducers:{
        add :(state,action)=>{
            state.details = action.payload 
        },
        changeType :(state,action)=>{
            state.details = action.payload
        },
        get:(state)=>{
            return state.details
        }
        
    }
})

export const {add,get,changeType} = CourseDetailsSlice.actions

export default CourseDetailsSlice.reducer